import Data from "~/util/data";

export class EmergencyInstruction extends Data {
    public constructor(
        public id: string,
        public description: string,
        public photograph_ids: string[] = [],
    ) {
        super();
    }
}
